<mat-card>
    <mat-card-header>
        <mat-card-title class="mb-0">
            {{'title.synchronized_customer' | translate}}
        </mat-card-title>
    </mat-card-header>

    <mat-card-content class="mb-3">
        <mat-accordion #accordion="matAccordion" [multi]="true">
            <mat-expansion-panel expanded="true" class="mt-3">
                <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
                    {{ "title.search_condition" | translate }}
                </mat-panel-title>
                <form #f="ngForm" class="pb-3" (ngSubmit)="onClickBtnFilter()" (keydown.enter)="onClickBtnFilter()">
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <input
                                    (focusout)="customer.taxCodeOrCertificateNo = customer.taxCodeOrCertificateNo == undefined ? '' : (customer.taxCodeOrCertificateNo + '').trim()"
                                    #focusInput matInput type="text"
                                    [placeholder]="'enterprise_customer_management.lbl_taxCodeOrCertificateNo' | translate"
                                    name="taxCodeOrCertificateNo" [(ngModel)]="customer.taxCodeOrCertificateNo" autocomplete="off" />
                                <button mat-button *ngIf="customer.taxCodeOrCertificateNo" type="button" matSuffix
                                    mat-icon-button aria-label="Clear" (click)="customer.taxCodeOrCertificateNo=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <!-- trang thai -->
                            <mat-form-field class="w-100">
                                <mat-select id="status" name="status"
                                    [placeholder]="'document_template.lbl_status' | translate"
                                    [(ngModel)]="customer.status" (ngModelChange)="onClickBtnFilter()">
                                    <mat-option value="null">
                                        {{
                                        "system_document_template.cbx_document_status.cbx_document_status_select_all"
                                        | translate
                                        }}
                                    </mat-option>
                                    <mat-option value="ACTIVE">
                                        {{
                                        "system_document_template.cbx_document_status.cbx_document_status_active"
                                        | translate
                                        }}
                                    </mat-option>
                                    <mat-option value="INACTIVE">
                                        {{
                                        "system_document_template.cbx_document_status.cbx_document_status_inactive"
                                        | translate
                                        }}
                                    </mat-option>
                                    <mat-option value="DRAFT">
                                        {{ "document_template.lbl_draft" | translate }}
                                    </mat-option>
                                </mat-select>
                                <button mat-button *ngIf="customer.status" type="button" matSuffix mat-icon-button
                                    aria-label="Clear" (click)="customer.status=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-center">
                            <button mat-stroked-button color="primary" type="submit">
                                <mat-icon class="mr-0" style="font-weight: 900">search</mat-icon>
                                {{ "search_form.search" | translate }}
                            </button>
                        </div>
                    </div>
                </form>

                <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
                    <span
                        *ngIf="!commonService.getIsLockedEnterprise()">{{'enterprise_customer_management.list_customer_sync'
                        |
                        translate}}
                        ({{paginate.totalRow}}), {{'enterprise_customer_management.selected' | translate}}
                        {{this.dataSelected.size}}
                    </span>
                    <span
                        *ngIf="commonService.getIsLockedEnterprise()">{{'enterprise_customer_management.list_customer_sync'
                        |
                        translate}}
                        ({{paginate.totalRow}})
                    </span>
                </mat-panel-title>

                <div class="mat-table-container">
                    <mat-table [dataSource]="dataSource" width="100%">
                        <!-- check-->
                        <ng-container matColumnDef="check">
                            <mat-header-cell *matHeaderCellDef
                                class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                                <mat-checkbox [disabled]="commonService.getIsLockedEnterprise()"
                                    *ngIf="dataSource && dataSource.data && dataSource.data.length > 0"
                                    [(ngModel)]="checkAll" (change)="checkAllDocument()" color="primary"></mat-checkbox>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                                (click)="$event.stopPropagation()">
                                <mat-checkbox color="primary" [(ngModel)]="element.checked"
                                    (change)="onSelectionChange(element)"
                                    [disabled]="!element.hasPermission ||commonService.getIsLockedEnterprise()">
                                </mat-checkbox>
                            </mat-cell>
                        </ng-container>
                        <!-- STT -->
                        <ng-container matColumnDef="id">
                            <mat-header-cell *matHeaderCellDef
                                class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                                {{'enterprise_customer_management.table_headers.No' | translate}}</mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                                {{paginate.no[dataSource.filteredData.indexOf(element)]}}</mat-cell>
                        </ng-container>

                        <!-- Tên khách hàng -->
                        <ng-container matColumnDef="name">
                            <mat-header-cell *matHeaderCellDef style="width: 20%;"
                                class="mat-cell-non-boder-right-bottom">
                                {{'enterprise_customer_management.table_headers.customer_name' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" matTooltip="{{element.name}}" matTooltipPosition="below"
                                style="width: 20%;" class="mat-cell-non-boder-right-bottom">
                                <span class="fix-width">{{element.name}}</span>
                            </mat-cell>
                        </ng-container>

                        <!-- MST/CMTND/Số giấy tờ -->
                        <ng-container matColumnDef="certificateNo">
                            <mat-header-cell *matHeaderCellDef style="max-width: 25%;"
                                class="mat-cell-non-boder-right-bottom">
                                {{'enterprise_customer_management.table_headers.taxCodeOrCertificateNo' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" style="max-width: 25%;"
                                class="mat-cell-non-boder-right-bottom number-cell-right"
                                matTooltip="{{element.customerType == personalId ? element.certificateNo : element.taxCode != null ? element.taxCode : element.certificateNo}}">
                                <span class="fix-width">{{element.customerType == personalId ? element.certificateNo :
                                    element.taxCode
                                    != null ? element.taxCode : element.certificateNo}}
                                </span>
                            </mat-cell>
                        </ng-container>

                        <!-- Email -->
                        <ng-container matColumnDef="email">
                            <mat-header-cell *matHeaderCellDef style="max-width: 20%;"
                                class="mat-cell-non-boder-right-bottom">
                                {{'enterprise_customer_management.table_headers.email' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" style="max-width: 20%;"
                                class="mat-cell-non-boder-right-bottom" matTooltip="{{element.email}}">
                                <span class="fix-width">{{element.email}}</span>
                            </mat-cell>
                        </ng-container>

                        <!-- Số điện thoại -->
                        <ng-container matColumnDef="phone">
                            <mat-header-cell *matHeaderCellDef style="max-width: 110px"
                                class="mat-cell-non-boder-right-bottom">
                                {{'enterprise_customer_management.table_headers.phone' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" style="max-width: 110px"
                                class="mat-cell-non-boder-right-bottom number-cell-center">
                                <span class="fix-width">{{element.phone}}</span>
                            </mat-cell>
                        </ng-container>

                        <!-- Loại khách hàng  -->
                        <ng-container matColumnDef="customerType">
                            <mat-header-cell *matHeaderCellDef style="max-width: 20%;">
                                {{'enterprise_customer_management.table_headers.customer_type' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" style="max-width: 20%;"
                                matTooltip="{{enterpriseTypeI18n.get(element.customerType) | translate}}">
                                <span class="fix-width">{{enterpriseTypeI18n.get(element.customerType) |
                                    translate}}</span>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                    </mat-table>
                </div>
                <div class="py-4" *ngIf="error">
                    <div class="card">
                        <p class="card-body text-danger" style="white-space: pre-wrap; padding-bottom: 0;">{{error}}</p>
                    </div>
                </div>
                <!-- Pagination -->
                <app-pagination [(paginate)]="paginate" (pageChange)="onFilterCustomers($event.page, $event.pageSize)">
                </app-pagination>
                <!-- /Pagination -->

                <!-- Huỷ bỏ & Đồng bộ & Đồng bộ tất cả  -->
                <div class="text-center mt-2 mb-2">
                    <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
                        <mat-icon class="mr-0">cancel</mat-icon>
                        {{'button.cancel' | translate}}
                    </button>
                    <button mat-raised-button type="button" color="primary" class="mr-3">
                        <mat-icon class="mr-0">save</mat-icon>
                        {{'button.synchronized' | translate}}
                    </button>
                    <button mat-raised-button type="button" color="primary">
                        <mat-icon class="mr-0">save</mat-icon>
                        {{'button.synchronized_all' | translate}}
                    </button>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-card-content>
</mat-card>
